export default "__VITE_ASSET__CE6UFJF4__"